// import { useEffect, useState } from "react";
// import Navbar from "../components/navbar";
// import Footer from "../components/footer";
// import { useNavigate } from "react-router-dom";
// import PatientAppointment from "../components/patientappoinment";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import doctor_consultation from "../assets/aura.gif";
// import image4 from "../assets/online-medical.png";
// import image5 from "../assets/pharmacy_new.png";
// import image6 from "../assets/medical-prescription.png";
// import doctor4 from "../assets/1.png";
// import doctor3 from "../assets/2.jpg";

// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Container,
//   Grid,
//   IconButton,
//   Modal,
//   Paper,
//   Typography,
//   useTheme,
//   styled,
//   useMediaQuery,
//   Fade,
//   Backdrop,
// } from "@mui/material";
// import { ChevronLeft, ChevronRight } from "@mui/icons-material";

// const HeroBackground = styled(Box)(({ theme }) => ({
//   position: "relative",
//   height: "70vh",
//   minHeight: "400px",
//   width: "100%",
//   overflow: "hidden",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   color: theme.palette.common.white,
//   [theme.breakpoints.down("md")]: {
//     height: "60vh",
//     minHeight: "350px",
//   },
//   [theme.breakpoints.down("sm")]: {
//     height: "50vh",
//     minHeight: "300px",
//   },
//   "&:before": {
//     content: '""',
//     position: "absolute",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: "rgba(0,0,0,0.4)",
//     zIndex: 1,
//   },
// }));

// const HeroContent = styled(Box)(({ theme }) => ({
//   position: "relative",
//   zIndex: 2,
//   textAlign: "center",
//   padding: theme.spacing(4),
//   maxWidth: "800px",
//   margin: "0 auto",
//   [theme.breakpoints.down("md")]: {
//     padding: theme.spacing(3),
//     maxWidth: "600px",
//   },
//   [theme.breakpoints.down("sm")]: {
//     padding: theme.spacing(2),
//     maxWidth: "90%",
//   },
// }));

// const ServiceCard = styled(Card)(({ theme }) => ({
//   height: "100%",
//   display: "flex",
//   flexDirection: "column",
//   transition: "transform 0.3s ease-in-out",
//   "&:hover": {
//     transform: "scale(1.03)",
//     boxShadow: theme.shadows[8],
//   },
//   [theme.breakpoints.down("sm")]: {
//     "&:hover": {
//       transform: "none",
//     },
//   },
// }));

// const Dot = styled("div")(({ active, theme }) => ({
//   width: 10,
//   height: 10,
//   borderRadius: "50%",
//   backgroundColor: active
//     ? theme.palette.primary.main
//     : theme.palette.grey[400],
//   margin: "0 4px",
//   cursor: "pointer",
//   transition: "background-color 0.3s",
//   [theme.breakpoints.down("sm")]: {
//     width: 8,
//     height: 8,
//     margin: "0 3px",
//   },
// }));

// const useTypingEffect = (text, speed = 100) => {
//   const [displayedText, setDisplayedText] = useState("");

//   useEffect(() => {
//     let index = 0;
//     const interval = setInterval(() => {
//       setDisplayedText((prev) => prev + text.charAt(index));
//       index++;
//       if (index >= text.length) clearInterval(interval);
//     }, speed);

//     return () => clearInterval(interval);
//   }, [text, speed]);

//   return displayedText;
// };

// export default function Home() {
//   const images = [doctor_consultation];
//   const [popup, setPopup] = useState(false);
//   const navigate = useNavigate();
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
//     }, 8000);

//     return () => clearInterval(interval);
//   }, [images.length]);

//   const nextImage = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
//   };

//   const prevImage = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? images.length - 1 : prevIndex - 1
//     );
//   };

//   const openup = () => {
//     setPopup(true);
//   };

//   const closeup = () => {
//     setPopup(false);
//   };

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//       <Box
//         id="home-section"
//         sx={{
//           position: "relative",
//           height: "100vh",
//           minHeight: { xs: "70vh", md: "85vh" },
//         }}
//       >
//         <HeroBackground
//           sx={{
//             height: "100%",
//             position: "relative",
//           }}
//         >
//           <Box
//             sx={{
//               position: "absolute",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "100%",
//               display: "flex",
//               justifyContent: "center",
//               overflow: "hidden",
//             }}
//           >
//             {images.map((img, index) => (
//               <Box
//                 key={index}
//                 component="img"
//                 src={img}
//                 alt={`Slide ${index + 1}`}
//                 sx={{
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   position: "absolute",
//                   opacity: index === currentIndex ? 1 : 0,
//                   transition: "opacity 1s ease-in-out",
//                 }}
//               />
//             ))}
//           </Box>

//           <HeroContent
//             sx={{
//               position: "relative",
//               zIndex: 3,
//               height: "100%",
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               alignItems: "center",
//               textAlign: "center",
//               px: 2,
//             }}
//           >
//             {/* Typing animation text */}
//             <Typography
//               variant={isMobile ? "h4" : isTablet ? "h3" : "h3"}
//               component="h1"
//               gutterBottom
//               sx={{
//                 fontWeight: 700,
//                 mb: { xs: 2, md: 3 },
//                 textShadow: "0 2px 4px rgba(0,0,0,0.5)",
//                 fontSize: {
//                   xs: "1.8rem",
//                   sm: "2.2rem",
//                   md: "2.5rem",
//                   lg: "3rem",
//                 },
//               }}
//             >
//               Welcome To Aura Meditation {/* "Welcome to Aura Meditation" typing */}
//             </Typography>

//             <Typography
//               variant={isMobile ? "h5" : isTablet ? "h4" : "h4"}
//               component="h2"
//               gutterBottom
//               sx={{
//                 fontWeight: 600,
//                 mb: { xs: 3, md: 4 },
//                 textShadow: "0 2px 4px rgba(0,0,0,0.5)",
//                 fontSize: {
//                   xs: "1.4rem",
//                   sm: "1.8rem",
//                   md: "2rem",
//                   lg: "2.2rem",
//                 },
//               }}
//             >
//              Book Your Appointments Here  {/* "Book Your Appointments Here" typing */}
//             </Typography>

//             {/* Book Appointment Button */}
//             <Button
//               variant="contained"
//               size={isMobile ? "medium" : "large"}
//               onClick={() => navigate("/patient-login")}
//               sx={{
//                 px: { xs: 4, md: 6 },
//                 py: { xs: 1, md: 1.5 },
//                 borderRadius: 2,
//                 fontSize: { xs: "1rem", md: "1.1rem" },
//                 fontWeight: "bold",
//                 textTransform: "none",
//                 boxShadow: theme.shadows[4],
//                 "&:hover": {
//                   boxShadow: theme.shadows[6],
//                 },
//               }}
//             >
//               Book Appointment
//             </Button>
//           </HeroContent>
//         </HeroBackground>
//       </Box>
//     </Box>
//   );
// }

import { useNavigate } from "react-router-dom";
import BackgroundVideo from "../assets/3.mp4";
import AuraLogo from "../assets/saloonlogo.png";
import BookedUsersDisplay from '../components/bookeduserdisplay.js';
// MUI Components
import {
  Box,
  Button,
  Typography,
  useTheme,
  styled,
  useMediaQuery,
} from "@mui/material";
import { keyframes } from "@mui/system";

const HeroBackground = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  height: "100vh",
  width: "100vw",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.common.white,
  zIndex: 0,
}));

const HeroContent = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: 2,
  textAlign: "center",
  padding: theme.spacing(4),
  maxWidth: "800px",
  margin: "0 auto",
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(3),
    maxWidth: "600px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
    maxWidth: "90%",
  },
}));

const Welcome = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const pulseLogo = keyframes`
    0% { 
      transform: scale(1); 
      filter: 
        contrast(1.1)
        brightness(1.05)
        saturate(1.2)
        drop-shadow(0 0 5px rgba(255, 255, 255, 0.3))
        drop-shadow(0 0 10px rgba(102, 51, 153, 0.4))
        drop-shadow(0 0 15px rgba(51, 204, 153, 0.3));
    }
    25% { 
      transform: scale(1.03); 
      filter: 
        contrast(1.15)
        brightness(1.08)
        saturate(1.3)
        drop-shadow(0 0 8px rgba(255, 255, 255, 0.4))
        drop-shadow(0 0 12px rgba(255, 99, 132, 0.4))
        drop-shadow(0 0 18px rgba(102, 51, 153, 0.3));
    }
    50% { 
      transform: scale(1.05); 
      filter: 
        contrast(1.2)
        brightness(1.1)
        saturate(1.4)
        drop-shadow(0 0 10px rgba(255, 255, 255, 0.5))
        drop-shadow(0 0 15px rgba(51, 204, 153, 0.5))
        drop-shadow(0 0 20px rgba(255, 99, 132, 0.4));
    }
    75% { 
      transform: scale(1.03); 
      filter: 
        contrast(1.15)
        brightness(1.08)
        saturate(1.3)
        drop-shadow(0 0 8px rgba(255, 255, 255, 0.4))
        drop-shadow(0 0 12px rgba(102, 51, 153, 0.4))
        drop-shadow(0 0 18px rgba(51, 204, 153, 0.3));
    }
    100% { 
      transform: scale(1); 
      filter: 
        contrast(1.1)
        brightness(1.05)
        saturate(1.2)
        drop-shadow(0 0 5px rgba(255, 255, 255, 0.3))
        drop-shadow(0 0 10px rgba(102, 51, 153, 0.4))
        drop-shadow(0 0 15px rgba(51, 204, 153, 0.3));
    }
  `;

  const handleBookAppointment = () => {
    navigate("/patient-login");
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", overflow: "hidden" }}>
      <Box
        id="welcome-section"
        sx={{
          position: "relative",
          height: "100vh",
          minHeight: "100vh",
          width: "100vw",
          overflow: "hidden",
        }}
      >
        <HeroBackground
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            zIndex: 0,
            overflow: "hidden",
          }}
        >
          {/* Video Background */}
          <Box
            component="video"
            src={BackgroundVideo}
            autoPlay
            muted
            loop
            playsInline
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              objectFit: "cover",
              objectPosition: "center",
              zIndex: 0,
              overflow: "hidden",
              maxWidth: "100%",
              maxHeight: "100%",
            }}
          />

          {/* Video Overlay */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "linear-gradient(135deg, rgba(102, 51, 153, 0.4) 0%, rgba(51, 204, 153, 0.3) 50%, rgba(255, 99, 132, 0.2) 100%)",
              zIndex: 1,
            }}
          />

          {/* Dark Layer for Better Text Visibility */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.4)",
              zIndex: 2,
            }}
          />

          {/* Additional Dark Layer for Enhanced Contrast */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.5) 50%, rgba(0, 0, 0, 0.6) 100%)",
              zIndex: 3,
            }}
          />

          {/* Extra Dark Vignette Effect */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "radial-gradient(circle at center, transparent 30%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0.5) 100%)",
              zIndex: 4,
            }}
          />

          <HeroContent
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 15,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              width: "100%",
              maxWidth: "800px",
              px: { xs: 2, md: 4 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                width: "100%",
                maxWidth: "500px",
                margin: "0 auto",
                gap: { xs: 3, sm: 4, md: 5 },
                padding: { xs: 2, sm: 3, md: 4 },
              }}
            >
              {/* Aura Logo */}
              <Box
                component="img"
                src={AuraLogo}
                alt="Aura Meditation Logo"
                sx={{
                  width: isMobile ? 180 : 220,
                  height: "auto",
                  alignSelf: "center",
                  mb: 2,
                  animation: `${pulseLogo} 3s infinite ease-in-out`,
                  filter: `
                    contrast(1.1)
                    brightness(1.05)
                    saturate(1.2)
                    drop-shadow(0 0 5px rgba(255, 255, 255, 0.3))
                    drop-shadow(0 0 10px rgba(102, 51, 153, 0.4))
                    drop-shadow(0 0 15px rgba(51, 204, 153, 0.3))
                  `,
                  backdropFilter: "blur(0px)",
                  WebkitBackdropFilter: "blur(0px)",
                  imageRendering: "crisp-edges",
                  WebkitImageRendering: "crisp-edges",
                  border: "2px solid rgba(255, 255, 255, 0.2)",
                  borderRadius: "50%",
                  padding: "8px",
                  background: "radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%)",
                }}
              />

              {/* <Typography
                variant={isMobile ? "h4" : "h2"}
                component="h1"
                sx={{
                  fontWeight: 700,
                  textShadow: "0 4px 8px rgba(0,0,0,0.7)",
                  color: "white",
                  textAlign: "center",
                  fontSize: {
                    xs: "2rem",
                    sm: "2.5rem",
                    md: "3rem",
                    lg: "3.5rem",
                  },
                  lineHeight: 1.2,
                }}
              >
                Book Your Appointments
              </Typography> */}
              
              <Button
                variant="contained"
                size="large"
                onClick={handleBookAppointment}
                sx={{
                  px: { xs: 4, md: 8 },
                  py: { xs: 1.5, md: 2.5 },
                  borderRadius: 3,
                  fontSize: { xs: "1rem", md: "2rem" },
                  fontWeight: "bold",
                  textTransform: "none",
                  boxShadow: "0 8px 32px rgba(186, 187, 187, 0.4)",
                  background: "linear-gradient(45deg, #464849ff 30%, #101111ff 90%)",
                  color: "white",
                  border: "2px solid rgba(42, 42, 43, 0.3)",
                  "&:hover": {
                    boxShadow: "0 12px 40px rgba(235, 237, 240, 0.6)",
                    background: "linear-gradient(45deg, #06080aff 30%, #323333ff 90%)",
                    transform: "translateY(-3px)",
                    border: "2px solid rgba(10, 10, 10, 0.5)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                Book Appointment
              </Button>
               <Box sx={{ mt: 3, width: '100%' }}>
                <Typography sx={{ color: 'white', mb: 1, fontWeight: 600 }}>Recently Booked Customer</Typography>
                <Box sx={{ bgcolor: 'rgba(255,255,255,0.04)', borderRadius: 2, p: 1 }}>
                  {/** We'll render a small list here; data comes from API or dummy fallback **/}
                  <BookedUsersDisplay />
                </Box>
              </Box>
            </Box>
          </HeroContent>
        </HeroBackground>
      </Box>
    </Box>
  );
};

export default Welcome;

